import React from 'react';
import { StarIcon } from 'lucide-react';
import { testimonials } from '../data/content';
export function Testimonials() {
  return <section className="bg-white px-3 py-4 sm:px-6" data-id="element-154" data-mp="3kqw54mwtl6h6">
      <div className="mx-auto max-w-2xl" data-id="element-155" data-mp="3fze45yusr5w7">
        <h2 className="text-center text-[1.1rem] font-black uppercase leading-tight text-navy sm:text-[1.6rem]" data-id="element-156" data-mp="3fy2z7vpm7s3i">
          WHAT TECHNICIANS ARE SAYING
        </h2>
        <div className="mt-2 space-y-2" data-id="element-157" data-mp="36ziophu7koqd">
          {testimonials.map(t => <figure key={t.name} className="rounded-md border border-navy/10 border-l-4 border-l-electric bg-ice px-2.5 py-2" data-id="element-158" data-mp="31zwc9am7fcim">
              <div className="flex gap-0.5 text-star" role="img" aria-label="5 out of 5 stars" data-id="element-159" data-mp="2x007381rtf1h">
                {Array.from({
              length: 5
            }).map((_, i) => <StarIcon key={i} className="h-3.5 w-3.5 fill-current" aria-hidden="true" data-id="element-160" data-mp="2s430vuk81p2f" data-mpi={i} />)}
              </div>
              <p className="mt-1 font-heading text-[0.84rem] font-extrabold leading-tight text-navy sm:text-[1rem]" data-id="element-161" data-mp="q9tvb9f0uee8">
                “{t.headline}”
              </p>
              <blockquote className="mt-0.5 text-[0.78rem] leading-[1.4] sm:text-[0.9rem]" data-id="element-162" data-mp="h8awv9l20jp4">“{t.quote}”</blockquote>
              <figcaption className="mt-1.5 text-[0.7rem] leading-tight sm:text-[0.8rem]" data-id="element-163" data-mp="780jnoz0rc9y">
                <span className="font-extrabold text-navy" data-id="element-164" data-mp="c6vejpa9graf">{t.name}</span>
                <span className="text-steel/80" data-id="element-165" data-mp="c73nx776degv">
                  {' '}
                  — {t.role} · {t.location}
                </span>
              </figcaption>
            </figure>)}
        </div>
      </div>
    </section>;
}